(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    var timer;

    function shell() { return document.querySelector('[data-cart]'); }

    function change(line, quantity) {
      var cart = shell();
      if (!cart) return;
      var sectionId = cart.getAttribute('data-cart-section');
      cart.setAttribute('aria-busy', 'true');

      fetch(cart.getAttribute('data-cart-change-url') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity, sections: [sectionId], sections_url: window.location.pathname })
      })
        .then(function (response) { return response.json().then(function (data) { return { ok: response.ok, data: data }; }); })
        .then(function (result) {
          if (!result.ok) throw new Error(result.data.description || result.data.message || 'That quantity is not available.');
          var html = result.data.sections && result.data.sections[sectionId];
          if (!html) return window.location.reload();
          var next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart]');
          var focused = document.activeElement && document.activeElement.id;
          cart.innerHTML = next.innerHTML;
          if (focused && document.getElementById(focused)) document.getElementById(focused).focus();
          badge(result.data.item_count);
        })
        .catch(function (error) {
          var status = cart.querySelector('[data-cart-status]');
          if (status) status.textContent = error.message;
        })
        .then(function () {
          cart.removeAttribute('aria-busy');
        });
    }

    // Keeps the header cart count in step with the cart page.
    function badge(count) {
      var link = document.querySelector('.site-header .header__icons > a');
      if (!link) return;
      var sup = link.querySelector('sup');
      if (count > 0) {
        if (!sup) { sup = document.createElement('sup'); link.insertBefore(sup, link.firstChild); }
        sup.textContent = count;
      } else if (sup) {
        sup.remove();
      }
    }

    function queue(input) {
      var quantity = Math.max(0, parseInt(input.value, 10) || 0);
      input.value = quantity;
      clearTimeout(timer);
      timer = setTimeout(function () { change(Number(input.getAttribute('data-cart-quantity')), quantity); }, 350);
    }

    document.addEventListener('click', function (event) {
      var step = event.target.closest('[data-cart-step]');
      if (step) {
        var input = step.parentNode.querySelector('[data-cart-quantity]');
        input.value = Math.max(0, (parseInt(input.value, 10) || 0) + Number(step.getAttribute('data-cart-step')));
        return queue(input);
      }
      var remove = event.target.closest('[data-cart-remove]');
      if (remove) {
        event.preventDefault();
        change(Number(remove.getAttribute('data-cart-remove')), 0);
      }
    });

    document.addEventListener('change', function (event) {
      if (event.target.matches('[data-cart-quantity]')) queue(event.target);
    });

    var cart = shell();
    if (cart) cart.setAttribute('data-cart-live', '');
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-catalog"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var map = document.querySelector('[data-trail-map]');
    if (!map) return;
    var svg = map.querySelector('[data-trail]');
    var paths = map.querySelectorAll('[data-trail-path]');
    var mask = map.querySelector('[data-trail-mask]');
    var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var length = 0;

    function lay() {
      var box = map.getBoundingClientRect();
      var points = [].map.call(map.querySelectorAll('[data-trail-stop]'), function (stop) {
        var r = stop.getBoundingClientRect();
        return [r.left + r.width / 2 - box.left, r.top + r.height / 2 - box.top];
      });
      if (points.length < 2) return;
      var d = 'M' + points[0][0] + ',' + points[0][1];
      for (var i = 1; i < points.length; i++) {
        var a = points[i - 1], b = points[i], mid = (a[1] + b[1]) / 2;
        d += ' C' + a[0] + ',' + mid + ' ' + b[0] + ',' + mid + ' ' + b[0] + ',' + b[1];
      }
      svg.setAttribute('viewBox', '0 0 ' + box.width + ' ' + box.height);
      [].forEach.call(paths, function (path) { path.setAttribute('d', d); });
      mask.setAttribute('d', d);
      length = mask.getTotalLength();
      mask.style.strokeDasharray = length;
      walk();
    }

    function walk() {
      if (!length) return;
      var box = map.getBoundingClientRect();
      var walked = still ? 1 : Math.min(1, Math.max(0, (window.innerHeight * 0.7 - box.top) / box.height));
      mask.style.strokeDashoffset = length * (1 - walked);
    }

    window.addEventListener('scroll', walk, { passive: true });
    window.addEventListener('resize', lay);
    window.addEventListener('load', lay);
    if ('ResizeObserver' in window) new ResizeObserver(lay).observe(map);
    lay();
  })();

  } catch(e) { console.error(e); }
})();
})();
